import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTypedSelector } from "./useTypedSelector";
import { toast } from "react-toastify";
import {
  useGetApplicantsSingleJobQuery,
  useResolveComplaintMutation,
  useUpdateAppSingleJobMutation,
} from "../store/query/applicants";

const useManageApplicants = () => {
  const { id } = useParams();
  const { user } = useTypedSelector((store) => store.appUser);
  const [filters, setFilters] = useState({
    id,
    acc_type: user?.account_type,
    status: 1,
    date_from: "",
    date_to: "",
    page: 1,
    type: "",
  });

  const { data, isLoading, refetch } = useGetApplicantsSingleJobQuery(filters, {
    skip: !filters,
  });
  //console.log("data-sharp", data, filters);
  const [updateAppSingleJob, { isLoading: isUpdating }] =
    useUpdateAppSingleJobMutation();

  const [resolveComplaint, { isLoading: isResolving }] =
    useResolveComplaintMutation();

  const updateApplicant = useCallback(
    async ({ option, appId }) => {
      const values = {
        job_id: id,
        _method: "PATCH",
      };
      const res = await updateAppSingleJob({
        values,
        option,
        type: user?.account_type,
        appId,
      });
      //console.log("res", res);

      if (res.data.status) {
        refetch();
        toast.success(res.data.message);
      } else {
        toast.error("Failed to Update Applicant");
      }
    },
    [id, updateAppSingleJob, user?.account_type, refetch]
  );

  const resolveComplaintFn = useCallback(
    async (data) => {
      const res = await resolveComplaint({
        values: { ...data, job_id: id },
        type: user?.account_type,
      });
      console.log("res", res, {
        values: data,
        type: user?.account_type,
        job_id: id,
      });

      if (res.data.status) {
        refetch();
        toast.success(res.data.message);
      } else {
        toast.error("Failed to Update Applicant");
      }
    },
    [id, resolveComplaint, user?.account_type, refetch]
  );

  useEffect(() => {
    refetch();
  }, [filters, refetch]);

  return {
    data,
    loading: isLoading || isUpdating || isResolving,
    updateApplicant,
    refetch,
    handleResolve: resolveComplaintFn,
    filters,
    setFilters,
  };
};

export default useManageApplicants;
